:host {
    display: block;
}

#register-company-view {
    height: 383px;
}

#content-container {
    max-width: 672px;
}

.card {
    min-height: 353px;
}

.bg-lyreco-green {
    background-color: #9AC31C;
}

@media screen and (min-width: 768px) {
    .zip-code-group {
        max-width: 157px;
    }
}
